import { SVGAttributes } from "react";

export const QuickbooksDesktopLogo = ({
  title,
  ...props
}: SVGAttributes<SVGElement> & {
  title?: string;
}) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 600 600"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>{title}</title>
      <circle cx="300" cy="300" r="300" fill="#2CA01C" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M383.38 183.341H400.047C464.476 183.341 516.717 235.573 516.717 300.005C516.717 364.438 464.476 416.67 400.047 416.67H316.645V103.342C340.579 103.342 359.979 122.741 359.979 146.674V373.338H400.047C440.475 373.338 473.383 340.438 473.383 300.005C473.383 259.573 440.475 226.673 400.047 226.673H383.38V183.341ZM199.974 416.65C135.539 416.65 83.3037 364.418 83.3037 299.986C83.3037 235.56 135.539 183.321 199.974 183.321H283.357V496.649C259.423 496.649 240.022 477.25 240.022 453.317V226.653H199.974C159.533 226.653 126.638 259.553 126.638 299.986C126.638 340.425 159.533 373.318 199.974 373.318H216.641V416.65H199.974Z"
        fill="white"
      />
    </svg>
  );
};
